import React from 'react';
import icons from '../../assets/icons';
import { UncontrolledTooltip } from 'reactstrap';
import './styles.scss';

const IconButton = ({
  id,
  icon,
  iconClass,
  imgClasses,
  btnClasses,
  onPress,
  tooltip,
  ariaLabel,
  disabled,
  loading
}) => {
  return (
    <button
      id={id}
      type="button"
      aria-label={ariaLabel || tooltip || icon}
      disabled={disabled}
      className={`btn icon-button ${btnClasses || ''}`}
      onClick={onPress}>
      {
        loading
          ? <span
              className="spinner-border spinner-border-sm"
              role="status" aria-hidden="true"/>
          : iconClass
            ? <i className={iconClass} aria-hidden="true" />
            : <img
                src={icons[icon]}
                alt={icon}
                className={imgClasses} />
      }
      { tooltip &&
        <UncontrolledTooltip placement="top" target={id}>
          { tooltip }
        </UncontrolledTooltip>
      }
    </button>
  )
};

export default IconButton;
